import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, ShieldOff } from "lucide-react";
import { api, useAuth, fileUrl } from "../lib/api";
import { Grid, Section, Page, Cover } from "../components/ComicCard";

export default function Home() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/home").then((r) => setD(r.data)); }, []);
  const hero = d?.promoted[0] || d?.trending[0];
  return (
    <Page>
      <section className="relative grid md:grid-cols-[1.2fr_1fr] gap-8 items-center jx-rise">
        <div>
          <div className="jx-tag jx-mint flex items-center gap-2"><ShieldOff size={12} />100% ad-free comics</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black mt-3 leading-[0.95]">Create. Read.<br /><span className="jx-pink">Earn</span> &amp; <span className="jx-gold">Sell.</span></h1>
          <p className="mt-5 jx-muted max-w-md text-base">Vertical comics with AI voices, a creator studio powered by AI, and a community where fans fund the stories they love.</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/discover" data-testid="hero-discover-btn" className="jx-btn px-6 py-3 flex items-center gap-2">Start reading <ArrowRight size={16} /></Link>
            <Link to={user ? "/create" : "/register"} data-testid="hero-create-btn" className="px-6 py-3 rounded-full border-2 border-[var(--jx-text)] font-bold flex items-center gap-2 hover:bg-[var(--jx-surface)] transition-colors"><Sparkles size={16} />Create with AI</Link>
          </div>
        </div>
        {hero && <Link to={`/comic/${hero.id}`} data-testid="hero-comic" className="relative block aspect-[4/3] md:aspect-[4/5] rounded-3xl overflow-hidden jx-ink rotate-[1.5deg] hover:rotate-0 transition-transform">
          <Cover src={hero.cover_url} className="w-full h-full" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent" />
          <div className="absolute bottom-0 p-5 text-white">
            {hero.is_boosted && <span className="jx-tag jx-promo px-2 py-0.5 rounded">Promoted</span>}
            <div className="font-display text-3xl font-black mt-2">{hero.title}</div>
            <div className="text-sm opacity-80 line-clamp-2">{hero.description}</div>
          </div>
        </Link>}
      </section>
      {!d ? <div className="mt-16 jx-muted">Loading comics…</div> : (<>
        {d.promoted.length > 1 && <Section title="Promoted picks" kicker="Boosted by creators"><Grid comics={d.promoted} testid="promoted-grid" /></Section>}
        {d.promoted_creators.length > 0 && <Section title="Creators to watch" kicker="Promoted profiles">
          <div className="flex gap-4 overflow-x-auto no-scrollbar">{d.promoted_creators.map((u) => (
            <Link key={u.id} to={`/u/${u.username}`} className="shrink-0 w-40 jx-surface rounded-2xl p-4 text-center">
              <img src={fileUrl(u.avatar_url) || "/icon-192.png"} alt="" className="w-16 h-16 rounded-full mx-auto object-cover" />
              <div className="font-bold mt-2 truncate">@{u.username}</div><span className="jx-tag jx-promo px-2 rounded">Promoted</span>
            </Link>))}</div>
        </Section>}
        <Section title="Trending now" kicker="Most read" action={<Link to="/discover" className="text-sm jx-pink">See all</Link>}><Grid comics={d.trending} testid="trending-grid" /></Section>
        <Section title="Fresh drops" kicker="New"><Grid comics={d.new} testid="new-grid" /></Section>
      </>)}
    </Page>
  );
}
